<template>
  <!--- help box --->
  <div class="help-container mobilefixhelp">
    <span :class="helpClass" @click="showPopup = true">?</span>
    <div
      class="help-content"
      :style="showPopup ? 'display:inline-block' : 'display:none'"
    >
      <span class="close" @click="showPopup = false">x</span>
      {{ msg }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Ref, ref } from "vue";

const props = defineProps({
  msg: {
    type: String,
    default: "",
  },
  helpClass: {
    type: String,
    default: "help",
  },
});
const showPopup: Ref<boolean> = ref(false);
</script>
